import { useCallback, useEffect, useState } from 'react';
import { apiClient } from './apiClient';
import { useStore } from '../store/useStore';

/** Start a full sync (runs in the background on the server) and resolve once
 *  the server reports it finished; then reload projects. */
export async function syncAllAndWait(): Promise<void> {
  await apiClient.post('/clickup/sync');
  for (let i = 0; i < 80; i++) {
    await new Promise((resolve) => setTimeout(resolve, 3000));
    const s = await apiClient.get<ClickUpStatus>('/clickup/status');
    if (!s.syncing) break;
  }
  await useStore.getState().refetchProjects();
}

export interface ClickUpStatus {
  configured: boolean;
  hourlyCost: number;
  lastSync: string | null;
  syncing: boolean;
}

export interface ClickUpListInfo {
  id: string;
  name: string;
  folderId: string | null;
  folderName: string | null;
  spaceId: string;
  spaceName: string;
}

/** Integration status + agency hourly cost, fetched once per mount. */
export function useClickUpStatus() {
  const [status, setStatus] = useState<ClickUpStatus | null>(null);

  const refresh = useCallback(async () => {
    try {
      setStatus(await apiClient.get<ClickUpStatus>('/clickup/status'));
    } catch {
      setStatus(null);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { status, refresh };
}
